module.exports = __webpack_public_path__ + "static/media/deer.57058fd7.svg";